"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AMERICA_TIMEZONE = 'America/New_York';
exports.DATE_IN_DST_STR = '2025-06-01';
